
<div mat-dialog-title>{{dTitle}}<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button><div class="dialog"></div></div>
<mat-dialog-content>
  @if (msg && (dType === 'ERROR' || dType === 'WARN')) {
    <mat-card class="block" [class]="{'error': dType === 'ERROR', 'warn': dType === 'WARN'}">
      <mat-card-title style="white-space: pre-line;">{{msg}}</mat-card-title>
    </mat-card>
  }
  @if (msg && (dType === 'NONE')) {
    <div class="block">{{msg}}</div>
  }
  @if (altMsg) {
    <div style="white-space: pre-line;">{{altMsg}}</div>
  }
  @if (altMsgHTML) {
    <div style="white-space: pre-line;" [innerHTML]="altMsgHTML"></div>
  }
  @if (altMsgTemplate) {
    <div style="word-wrap: break-word;" class="templateContainer"><ng-container *ngTemplateOutlet="altMsgTemplate"></ng-container></div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button (click)="continue()" class="btn-medium-primary">{{dProceedBtnLabel}}</button>
</mat-dialog-actions>
